import ShareDiscovery from "./ShareDiscovery";

export default ShareDiscovery;
